import BaseCtrl from 'edge/platform/base/BaseCtrl';
import moment from 'moment';
import _ from 'lodash';

const fn = ($scope, ActivityService, $stateParams, UserService, $filter) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.cancellationNumber = $stateParams.cancellationNumber;
    $scope.unfilteredActivities = [];

    /* Activity Summary Config*/
    $scope.activityTableConfig = {
        actStatus: 'allOpen',
        defaultActStatus: 'allOpen',
        actStatusOptions: {
            'allOpen': 'gateway.directives.ActivitySummary.All Open',
            'allClosed': 'gateway.directives.ActivitySummary.All Closed',
            'overdue': 'gateway.directives.ActivitySummary.Overdue',
            'openAssignedToMe': 'gateway.directives.ActivitySummary.Open, Assigned to me'
        },
        showAddActivity: false
    };

    ActivityService.getActivitiesForJob($stateParams.cancellationNumber).then((activitiesFromServer) => {
        $scope.unfilteredActivities = activitiesFromServer;
        filterActivities();
    });

    ctrl.showAddActivity = () => {
        $scope.activityTableConfig.showAddActivity = true;
    };

    // Check that the user has the permission to create activities
    ctrl.shouldShowAddActivityButton = () => {
        if ($scope.cancellation.statusCode === 'NotTaken') {
            $scope.showAddActivityButton = false;
            return;
        }

        const permissionDTO = {
            permission: 'actcreate'
        };

        const actPromise = UserService.hasUserSystemPermission(permissionDTO);

        actPromise.then((showActivity) => {
            $scope.showAddActivityButton = showActivity;
        });
    };

    $scope.$watch('cancellation', () => {
        if (angular.isDefined($scope.cancellation)) {
            ctrl.shouldShowAddActivityButton();
        }
    });


    function filterActivities() {
        let filteredActivities = $scope.unfilteredActivities;

        if ($scope.activityTableConfig.actStatus) {
            filteredActivities = $filter('filter')(filteredActivities, filterByActivityStatus);
        }
        if ($scope.activityTableConfig.search) {
            filteredActivities = $filter('filter')(filteredActivities, activitySearchFilter);
        }

        $scope.activities = filteredActivities;
    }

    /**
     * Custom search filter for Activity Summaries
     *
     * @param {Object} activity
     * @returns {Boolean} - true if the filter string matches the activity due date, subject, or accountholder name, otherwise false
     */
    function activitySearchFilter(activity) {
        const lowerCaseSearch = _.lowercase($scope.activityTableConfig.search);

        return activityDateFilter(lowerCaseSearch, activity.dueDate) ||
            activitySubjectFilter(lowerCaseSearch, activity.subject) ||
            activityAssigneeFilter(lowerCaseSearch, activity.assignedTo.displayName) ||
            activityAccountHolderFilter(lowerCaseSearch, activity.accountHolderName);
    }


    function activityDateFilter(search, dueDate) {
        return (angular.isDefined(dueDate) && _.lowercase($filter('date')(dueDate, 'shortDate')).indexOf(search || '') !== -1);
    }

    function activitySubjectFilter(search, subject) {
        return _.lowercase(subject).indexOf(search || '') !== -1;
    }

    function activityAccountHolderFilter(search, accountHolder) {
        return _.lowercase(accountHolder).indexOf(search || '') !== -1;
    }

    function activityAssigneeFilter(search, assignee) {
        return _.lowercase(assignee).indexOf(search || '') !== -1;
    }

    function filterByActivityStatus(activity) {
        switch ($scope.activityTableConfig.actStatus) {
            case 'allOpen':
                return activity.status === 'open';
            case 'overdue':
                return activity.status === 'open' && moment(activity.dueDate).isBefore(moment(), 'day');
            case 'allClosed':
                return activity.status === 'complete';
            case 'openAssignedToMe':
                return activity.isAssignedToCurrentUser === true && activity.status === 'open';
            default:
                return false;
        }
    }

    $scope.$watch('activityTableConfig', () => {
        filterActivities();
    }, true);

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'ActivityService', '$stateParams', 'UserService', '$filter'];

export default fn;
